import { SORT_PARAMETERS } from '~/constants/sortParameters';
import type { SortOption } from '~/types/modules/sort';

export const COMMENT_SORT_OPTIONS: SortOption[] = [
  { label: '新着順', target: SORT_PARAMETERS.CREATED_AT, index: 0 },
  { label: '評価の高い順', target: SORT_PARAMETERS.RATING_ASCENDING, index: 1 },
  { label: '評価の低い順', target: SORT_PARAMETERS.RATING_DESCENDING, index: 2 },
  { label: '役に立ったが多い順 ', target: SORT_PARAMETERS.LIKES, index: 3 },
];

// クチコミ画面の種類
export const COMMENT_PAGES: Record<string, string> = {
  MYPAGE: 'mypage',
  USER: 'user',
  PRODUCT: 'product',
};
